import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login';
import Projects from '../views/Projects';
import Register from '../views/Register';
// import CheckRole from '../views/Projects/CheckRole';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,

    meta: {
      title: 'Login',
    },
  },
  // {
  //   path: '/check-role',
  //   name: 'CheckRole',
  //   component: CheckRole,

  //   meta: {
  //     title: 'Projetos',
  //   },
  // },
  {
    path: '/projects',
    name: 'Projects',
    component: Projects,

    meta: {
      title: 'Projetos',
    },
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,

    meta: {
      title: 'Cadastro',
    },
  },

  {
    path: '*',
    redirect: '/login',
  },
  {
    path: '/',
    redirect: '/login',
  },
];

const router = new VueRouter({
  mode: 'history',
  // eslint-disable-next-line no-undef
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const publicPages = ['/login'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = !!sessionStorage.getItem('Orcamento:token');

  if (authRequired && !loggedIn) {
    next('/login');
  } else {
    next();
  }
});

export default router;
